import { fetchTranslations } from '@/lib/api';
import { logger } from '@/lib/logger';

type TranslationsMap = {
  [langCode: string]: Record<string, string>;
};

export interface Language {
  id: number;
  name: string;
  shortcode: string;
}

export const getAllTranslations = async (
  languages: Language[],
): Promise<TranslationsMap> => {
  const translationPromises = languages.map(async (lang: Language) => {
    try {
      const translations = await fetchTranslations(lang.shortcode);
      return { lang: lang.shortcode, translations };
    } catch (error) {
      const typedError = error as Error & { digest?: string };
      logger.error(typedError.message, {
        source: 'nextjs-app-fetchTranslations',
        digest: typedError.digest,
        stack: typedError.stack,
      });
      return { lang: lang.shortcode, translations: null };
    }
  });

  const results = await Promise.allSettled(translationPromises);

  const translationsMap: TranslationsMap = {};

  results.forEach(result => {
    if (result.status === 'fulfilled') {
      translationsMap[result.value.lang] = result.value.translations || {};
    } else {
      logger.error(`Failed to fetch translations for ${result.reason.lang}`, {
        source: 'nextjs-app-fetchTranslations',
      });
      translationsMap[result.reason.lang] = {};
    }
  });

  return translationsMap;
};
